import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import api from '@/src/lib/api';
import { urlHostResolver } from '@/src/lib/utils';
import CompanyPrivacy from '@/src/views/root/CompanyPrivacy';

function PrivacyPage({ data }) {
  return (
    <AssembleLayout Layout={MainLayout} Component={CompanyPrivacy} data={data}>
      <NextSeo
        title="Política de privacidade"
        description="Entenda como funciona a nossa política de privacidade e como garantimos suas informações pessoais. Respeitamos a sua privacidade e trabalhos de forma cuidadosa com os dados compartilhados."
        openGraph={{
          title: 'Política de privacidade',
          url: urlHostResolver('/privacy'),
        }}
      />
    </AssembleLayout>
  );
}

export async function getStaticProps() {
  const res = await api.get('/commons/privacy/latest/', { params: { type: 'platform' } });
  const { data } = res;

  return { props: { data } };
}

PrivacyPage.propTypes = {
  data: PropTypes.object,
};

export default PrivacyPage;
